import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import LoginPage from './pages/LoginPage'
import HomePage from './pages/HomePage'
import PlayDesignerPage from './pages/PlayDesignerPage'
import PlayViewPage from './pages/PlayViewPage'
import PracticePlannerPage from './pages/PracticePlannerPage'
import PracticeViewPage from './pages/PracticeViewPage'
import ProtectedRoute from './components/ProtectedRoute'

function App() {
  return (
    <Routes>
      {/* Login page - accessible without authentication */}
      <Route path="/login" element={<LoginPage />} />
      
      {/* Home page - protected route, requires authentication */}
      <Route
        path="/home"
        element={
          <ProtectedRoute>
            <HomePage />
          </ProtectedRoute>
        }
      />
      
      {/* Soccer Designer - protected route, requires authentication */}
      <Route
        path="/soccer-designer"
        element={
          <ProtectedRoute>
            <PlayDesignerPage />
          </ProtectedRoute>
        }
      />
      
      {/* Play View - protected route, requires authentication */}
      <Route
        path="/play-view/:playId"
        element={
          <ProtectedRoute>
            <PlayViewPage />
          </ProtectedRoute>
        }
      />
      
      {/* Practice Planner - protected route, requires authentication */}
      <Route
        path="/practice-planner"
        element={
          <ProtectedRoute>
            <PracticePlannerPage />
          </ProtectedRoute>
        }
      />
      
      {/* Practice View - protected route, requires authentication */}
      <Route
        path="/practice-view/:sessionId"
        element={
          <ProtectedRoute>
            <PracticeViewPage />
          </ProtectedRoute>
        }
      />
      
      {/* Root path redirects to home (or login if not authenticated) */}
      <Route path="/" element={<Navigate to="/home" replace />} />
      
      {/* Catch all - redirect to home */}
      <Route path="*" element={<Navigate to="/home" replace />} />
    </Routes>
  )
}

export default App
